export const uploadFilesType = {
  POST_UPLOAD_FILE_PENDING: "[UPLOAD_FILE][REQUEST] Create Upload file",
  POST_UPLOAD_FILE_FAILURE:
    "[UPLOAD_FILE][RESPONSE]  Upload file Creation Failed",
  POST_UPLOAD_FILE_SUCCESS:
    "[UPLOAD_FILE][RESPONSE]  Upload file Created Successfull",
  UPLOAD_FILE_PAGE: "UploadFilePage",
};
